import { ILayoutState } from '../../types/reducers/layout';

export const defaultState: ILayoutState = {
  adaptiveSettings: {
    deviceType: 'phone',
    deviceOperatingSystem: 'ios',
    isMobile: true,
  },
};
